import { MapPoint } from '@/map-display';

export const TimezoneLookupService = Symbol('TimezoneLookupService');

export type TimezoneIdentifier = string;
export interface TimezoneLookupService {
  getTimezone(point: MapPoint): Promise<TimezoneIdentifier>;
}
